<div class="page-header">
    <a routerLink="/faq-categorieen/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "faq-categories.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-faq-category-detail-form [faqCategory]="faqCategory$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>